const countryCode = [
	[ 'Angola', '安哥拉', 'AO', '-7' ], 
	[ 'Afghanistan', '阿富汗', 'AF', '0' ], 
	[ 'Albania', '阿尔巴尼亚', 'AL', '-7' ], 
	[ 'Algeria', '阿尔及利亚', 'DZ', '-8' ], 
	[ 'Andorra', '安道尔共和国', 'AD', '-8' ], 
	[ 'Anguilla', '安圭拉岛', 'AI', '-12' ], 
	[ 'Antigua and Barbuda', '安提瓜和巴布达', 'AG', '-12' ], 
	[ 'Argentina', '阿根廷', 'AR', '-11' ], 
	[ 'Armenia', '亚美尼亚', 'AM', '-6' ], 
	[ 'Australia', '澳大利亚', 'AU', '+2' ], 
	[ 'Austria', '奥地利', 'AT', '-7' ], 
	[ 'Azerbaijan', '阿塞拜疆', 'AZ', '-5' ], 
	[ 'Bahamas', '巴哈马', 'BS', '-13' ], 
	[ 'Bahrain', '巴林', 'BH', '-5' ], 
	[ 'Bangladesh', '孟加拉国', 'BD', '-2' ], 
	[ 'Barbados', '巴巴多斯', 'BB', '-12' ], 
	[ 'Belarus', '白俄罗斯', 'BY', '-6' ], 
	[ 'Belgium', '比利时', 'BE', '-7' ], 
	[ 'Belize', '伯利兹', 'BZ', '-14' ], 
	[ 'Benin', '贝宁', 'BJ', '-7' ], 
	[ 'Bermuda Is.', '百慕大群岛', 'BM', '-12' ], 
	[ 'Bolivia', '玻利维亚', 'BO', '-12' ], 
	[ 'Botswana', '博茨瓦纳', 'BW', '-6' ], 
	[ 'Brazil', '巴西', 'BR', '-11' ], 
	[ 'Brunei', '文莱', 'BN', '0' ], 
	[ 'Bulgaria', '保加利亚', 'BG', '-6' ], 
	[ 'Burkina-faso', '布基纳法索', 'BF', '-8' ], 
	[ 'Burma', '缅甸', 'MM', '-1.3' ], 
	[ 'Burundi', '布隆迪', 'BI', '-6' ], 
	[ 'Cameroon', '喀麦隆', 'CM', '-7' ], 
	[ 'Canada', '加拿大', 'CA', '-13' ], 
	[ 'Central African Republic', '中非共和国', 'CF', '-7' ], 
	[ 'Chad', '乍得', 'TD', '-7' ], 
	[ 'Chile', '智利', 'CL', '-13' ], 
	[ 'China', '中国', 'CN', '0' ],
	[ 'Colombia', '哥伦比亚', 'CO', '0' ], 
	[ 'Congo', '刚果', 'CG', '-7' ], 
	[ 'Cook Is.', '库克群岛', 'CK', '-18.3' ], 
	[ 'Costa Rica', '哥斯达黎加', 'CR', '-14' ], 
	[ 'Cuba', '古巴', 'CU', '-13' ], 
	[ 'Cyprus', '塞浦路斯', 'CY', '-6' ], 
	[ 'Czech Republic', '捷克', 'CZ', '-7' ], 
	[ 'Denmark', '丹麦', 'DK', '-7' ], 
	[ 'Djibouti', '吉布提', 'DJ', '-5' ], 
	[ 'Dominica Rep.', '多米尼加共和国', 'DO', '-13' ], 
	[ 'Ecuador', '厄瓜多尔', 'EC', '-13' ], 
	[ 'Egypt', '埃及', 'EG', '-6' ], 
	[ 'EI Salvador', '萨尔瓦多', 'SV', '-14' ], 
	[ 'Estonia', '爱沙尼亚', 'EE', '-5' ], 
	[ 'Ethiopia', '埃塞俄比亚', 'ET', '-5' ], 
	[ 'Fiji', '斐济', 'FJ', '+4' ], 
	[ 'Finland', '芬兰', 'FI', '-6' ], 
	[ 'France', '法国', 'FR', '-8' ], 
	[ 'French Guiana', '法属圭亚那', 'GF', '-12' ], 
	[ 'Gabon', '加蓬', 'GA', '-7' ], 
	[ 'Gambia', '冈比亚', 'GM', '-8' ], 
	[ 'Georgia', '格鲁吉亚', 'GE', '0' ], 
	[ 'Germany', '德国', 'DE', '-7' ], 
	[ 'Ghana', '加纳', 'GH', '-8' ], 
	[ 'Gibraltar', '直布罗陀', 'GI', '-8' ], 
	[ 'Greece', '希腊', 'GR', '-6' ], 
	[ 'Grenada', '格林纳达', 'GD', '-14' ], 
	[ 'Guam', '关岛', 'GU', '+2' ], 
	[ 'Guatemala', '危地马拉', 'GT', '-14' ], 
	[ 'Guinea', '几内亚', 'GN', '-8' ], 
	[ 'Guyana', '圭亚那', 'GY', '-11' ], 
	[ 'Haiti', '海地', 'HT', '-13' ], 
	[ 'Honduras', '洪都拉斯', 'HN', '-14' ], 
	[ 'Hongkong', '香港', 'HK', '0' ], 
	[ 'Hungary', '匈牙利', 'HU', '-7' ], 
	[ 'Iceland', '冰岛', 'IS', '-9' ], 
	[ 'India', '印度', 'IN', '-2.3' ], 
	[ 'Indonesia', '印度尼西亚', 'ID', '-0.3' ], 
	[ 'Iran', '伊朗', 'IR', '-4.3' ], 
	[ 'Iraq', '伊拉克', 'IQ', '-5' ], 
	[ 'Ireland', '爱尔兰', 'IE', '-4.3' ], 
	[ 'Israel', '以色列', 'IL', '-6' ], 
	[ 'Italy', '意大利', 'IT', '-7' ], 
	[ 'Jamaica', '牙买加', 'JM', '-12' ], 
	[ 'Japan', '日本', 'JP', '+1' ], 
	[ 'Jordan', '约旦', 'JO', '-6' ], 
	[ 'Kampuchea (Cambodia )', '柬埔寨', 'KH', '-1' ], 
	[ 'Kazakstan', '哈萨克斯坦', 'KZ', '-5' ], 
	[ 'Kenya', '肯尼亚', 'KE', '-5' ], 
	[ 'Korea', '韩国', 'KR', '+1' ], 
	[ 'Kuwait', '科威特', 'KW', '-5' ], 
	[ 'Kyrgyzstan', '吉尔吉斯坦', 'KG', '-5' ], 
	[ 'Laos', '老挝', 'LA', '-1' ], 
	[ 'Latvia', '拉脱维亚', 'LV', '-5' ], 
	[ 'Lebanon', '黎巴嫩', 'LB', '-6' ], 
	[ 'Lesotho', '莱索托', 'LS', '-6' ], 
	[ 'Liberia', '利比里亚', 'LR', '-8' ], 
	[ 'Libya', '利比亚', 'LY', '-6' ], 
	[ 'Liechtenstein', '列支敦士登', 'LI', '-7' ], 
	[ 'Lithuania', '立陶宛', 'LT', '-5' ], 
	[ 'Luxembourg', '卢森堡', 'LU', '-7' ], 
	[ 'Macao', '澳门', 'MO', '0' ], 
	[ 'Madagascar', '马达加斯加', 'MG', '-5' ], 
	[ 'Malawi', '马拉维', 'MW', '-6' ], 
	[ 'Malaysia', '马来西亚', 'MY', '-0.5' ], 
	[ 'Maldives', '马尔代夫', 'MV', '-7' ], 
	[ 'Mali', '马里', 'ML', '-8' ], 
	[ 'Malta', '马耳他', 'MT', '-7' ], 
	[ 'Mauritius', '毛里求斯', 'MU', '-4' ], 
	[ 'Mexico', '墨西哥', 'MX', '-15' ], 
	[ 'Moldova, Republic of', '摩尔多瓦', 'MD', '-5' ], 
	[ 'Monaco', '摩纳哥', 'MC', '-7' ], 
	[ 'Mongolia', '蒙古', 'MN', '0' ], 
	[ 'Montserrat Is', '蒙特塞拉特岛', 'MS', '-12' ],
	[ 'Morocco', '摩洛哥', 'MA', '-6' ], 
	[ 'Mozambique', '莫桑比克', 'MZ', '-6' ], 
	[ 'Namibia', '纳米比亚', 'NA', '-7' ], 
	[ 'Nauru', '瑙鲁', 'NR', '+4' ], 
	[ 'Nepal', '尼泊尔', 'NP', '-2.3' ], 
	[ 'Netherlands', '荷兰', 'NL', '-7' ], 
	[ 'New Zealand', '新西兰', 'NZ', '+4' ], 
	[ 'Nicaragua', '尼加拉瓜', 'NI', '-14' ], 
	[ 'Niger', '尼日尔', 'NE', '-8' ], 
	[ 'Nigeria', '尼日利亚', 'NG', '-7' ], 
	[ 'North Korea', '朝鲜', 'KP', '+1' ], 
	[ 'Norway', '挪威', 'NO', '-7' ], 
	[ 'Oman', '阿曼', 'OM', '-4' ], 
	[ 'Pakistan', '巴基斯坦', 'PK', '-2.3' ], 
	[ 'Panama', '巴拿马', 'PA', '-13' ], 
	[ 'Papua New Cuinea', '巴布亚新几内亚', 'PG', '+2' ], 
	[ 'Paraguay', '巴拉圭', 'PY', '-12' ], 
	[ 'Peru', '秘鲁', 'PE', '-13' ], 
	[ 'Philippines', '菲律宾', 'PH', '0' ], 
	[ 'Poland', '波兰', 'PL', '-7' ], 
	[ 'French Polynesia', '法属玻利尼西亚', 'PF', '+3' ], 
	[ 'Portugal', '葡萄牙', 'PT', '-8' ], 
	[ 'Puerto Rico', '波多黎各', 'PR', '-12' ], 
	[ 'Qatar', '卡塔尔', 'QA', '-5' ], 
	[ 'Romania', '罗马尼亚', 'RO', '-6' ], 
	[ 'Russia', '俄罗斯', 'RU', '-5' ], 
	[ 'Saint Lueia', '圣卢西亚', 'LC', '-12' ], 
	[ 'Saint Vincent', '圣文森特岛', 'VC', '-12' ], 
	[ 'San Marino', '圣马力诺', 'SM', '-7' ], 
	[ 'Sao Tome and Principe', '圣多美和普林西比', 'ST', '-8' ], 
	[ 'Saudi Arabia', '沙特阿拉伯', 'SA', '-5' ], 
	[ 'Senegal', '塞内加尔', 'SN', '-8' ], 
	[ 'Seychelles', '塞舌尔', 'SC', '-4' ], 
	[ 'Sierra Leone', '塞拉利昂', 'SL', '-8' ], 
	[ 'Singapore', '新加坡', 'SG', '+0.3' ], 
	[ 'Slovakia', '斯洛伐克', 'SK', '-7' ], 
	[ 'Slovenia', '斯洛文尼亚', 'SI', '-7' ], 
	[ 'Solomon Is', '所罗门群岛', 'SB', '+3' ], 
	[ 'Somali', '索马里', 'SO', '-5' ], 
	[ 'South Africa', '南非', 'ZA', '-6' ], 
	[ 'Spain', '西班牙', 'ES', '-8' ], 
	[ 'Sri Lanka', '斯里兰卡', 'LK', '0' ], 
	[ 'Sudan', '苏丹', 'SD', '-6' ], 
	[ 'Suriname', '苏里南', 'SR', '-11.3' ], 
	[ 'Swaziland', '斯威士兰', 'SZ', '-6' ], 
	[ 'Sweden', '瑞典', 'SE', '-7' ], 
	[ 'Switzerland', '瑞士', 'CH', '-7' ], 
	[ 'Syria', '叙利亚', 'SY', '-6' ], 
	[ 'Taiwan', '台湾省', 'TW', '0' ], 
	[ 'Tajikstan', '塔吉克斯坦', 'TJ', '-5' ], 
	[ 'Tanzania', '坦桑尼亚', 'TZ', '-5' ], 
	[ 'Thailand', '泰国', 'TH', '-1' ], 
	[ 'Togo', '多哥', 'TG', '-8' ], 
	[ 'Tonga', '汤加', 'TO', '+4' ], 
	[ 'Trinidad and Tobago', '特立尼达和多巴哥', 'TT', '-12' ],
	[ 'Tunisia', '突尼斯', 'TN', '-7' ], 
	[ 'Turkey', '土耳其', 'TR', '-6' ], 
	[ 'Turkmenistan', '土库曼斯坦', 'TM', '-5' ], 
	[ 'Uganda', '乌干达', 'UG', '-5' ], 
	[ 'Ukraine', '乌克兰', 'UA', '-5' ], 
	[ 'United Arab Emirates', '阿拉伯联合酋长国', 'AE', '-4' ], 
	[ 'United Kiongdom', '英国', 'GB', '-8' ], 
	[ 'United States of America', '美国', 'US', '-13' ], 
	[ 'Uruguay', '乌拉圭', 'UY', '-10.3' ], 
	[ 'Uzbekistan', '乌兹别克斯坦', 'UZ', '-5' ], 
	[ 'Venezuela', '委内瑞拉', 'VE', '-12.3' ], 
	[ 'Vietnam', '越南', 'VN', '-1' ], 
	[ 'Yemen', '也门', 'YE', '-5' ], 
	[ 'Yugoslavia', '南斯拉夫', 'YU', '-7' ], 
	[ 'Zimbabwe', '津巴布韦', 'ZW', '-6' ], 
	[ 'Zaire', '扎伊尔', 'ZR', '-7' ], 
	[ 'Zambia', '赞比亚', 'ZM', '-6' ]
];

export {countryCode};